/** Shared dense layout for DataGridPro and other screens (e.g. LTL Dashboard). */
export const MATERIAL_TABLE_GLOBAL_DENSE_STORAGE_KEY = 'jyswms-materialTable-dense-mode';
export const MATERIAL_TABLE_DENSE_SYNC_EVENT = 'jyswms-materialTable-dense-sync';
/** Min time to show dense-mode indicator so nested tables can repaint visibly. */
export const DENSE_MODE_APPLY_INDICATOR_MS = 320;

export function readGlobalDenseModeEnabled() {
  try {
    const saved = localStorage.getItem(MATERIAL_TABLE_GLOBAL_DENSE_STORAGE_KEY);
    if (saved === 'true') return true;
    if (saved === 'false') return false;
    return false;
  } catch (error) {
    console.error('Failed to load dense mode:', error);
    return false;
  }
}
